interface State {
    helpModal: boolean
}

const defaults = () => {
    return {
        helpModal: null
    }
}

export default {
    state: defaults(),
    mutations: {
        helpModalReset (state: State): void {
            Object.assign(state, defaults())
        },
        helpModalSet (state: State, bool: boolean): void {
            //  Sets our helpModal to obj, if obj = null, we close
            state.helpModal = bool
        },
    },
    getters: {
        helpModal (state: State): boolean {
            return state.helpModal
        }
    }
}